import { TaxesModel } from "../sociedades/model-202/model-202.model";

export class Taxes193Model extends TaxesModel {

  periodoComplementaria: boolean;
  periodoComplementariaJustificante: string;

  identificacionTipoVia: string;
  identificacionCalle: string;
  identificacionNumero: string;
  identificacionEscalera: string;
  identifacacionPiso: string;
  identificacionPuerta: string;
  identificacionTelefono: string;
  identificacionPronvincia: string;
  identificacionMunicipio: string;
  identificacionCP: string;
  identificacionFax: string;
  identificacionConjunta: boolean;
  identificacionRECC: boolean;
  identificacionRECCDestinatario: boolean;
  identificacionNoEstableciada: boolean;
  identificacionConcurso: boolean;
  identificacionConcursoFecha: string;
  indentificacionConcursoTipo: string;

  devISPBase_19: number;
  devISPCuota_20: number;
  devModBase_21: number;
  devModCuota_22: number;
  devViajeroBase_23: number;
  devViajeroCuota_24: number;
  devTotal_25: number;

  dedIntCorBase_26: number;
  dedIntCorCuota_27: number;
  dedIntInvBase_28: number;
  dedIntInvCuota_29: number;
  dedImpCorBase_30: number;
  dedImpCorCuota_31: number;
  dedImpInvBase_32: number;
  dedImpInvCuota_33: number;
  dedRectBase_34: number;
  dedRectCuota_35: number;
  dedREAGPCuota_36: number;
  dedRegInvCuota_37: number;
  dedRegAntesCuota_38: number;
  dedRegProrrata_39: number;
  dedTotalCuota_40: number;

  resultadoDiferencia_41: number;
  resultadoRegularizacion_42: number;
  resultadoCompensar_43: number;
  resultadoDeducir_44: number;
  resultadoResultado_45: number;

  adicionalExportacionCuota_46: number;
  adicionalNoSujetasISP_47: number;

  reccEntregaBase_48: number;
  reccEntregaCuota_49: number;
  reccAdqBase_50: number;
  reccAdqCuota_51: number;


  periodo: string;
  deV_OIN_BAS: number;
  deV_OIN_CUO: number;
  deV_MBC_BAS: number;
  deV_MBC_CUO: number;
  deV_CRV_BAS: number;
  deV_CRV_CUO: number;
  deV_TOT_CUO: number;
  deD_OIC_BAS: number;
  deD_OIC_CUO: number;
  deD_OII_BAS: number;
  deD_OII_CUO: number;
  deD_IMC_BAS: number;
  deD_IMC_CUO: number;
  deD_IMI_BAS: number;
  deD_IMI_CUO: number;
  deD_RED_BAS: number;
  deD_RED_CUO: number;
  deD_CRA_CUO: number;
  deD_RBI_CUO: number;
  deD_RIA_CUO: number;
  deD_RPP_CUO: number;
  deD_TOT_CUO: number;
  liQ_DIF: number;
  liQ_RCU: number;
  liQ_CPA: number;
  liQ_DAC: number;
  liQ_RLI: number;
  adI_EOA: number;
  adI_ODD: number;
  resultadoIngreso_I: number;
  resultadoDevolucion_D: number;
  resultadoCompensar_C: number;
  resultadoIBANingreso: string;
  resultadoIBANdevolucion: string;
  resultadoSinActividad: string;
  deC_ANY: string;
  deC_PER: string;
  deC_MOD: string;
  deC_ADM: string;
  otP_SEC: number;
  otP_TPE: string;
  otP_NIF: string;
  otP_NRS: string;
  otP_SVP: string;
  otP_NVP: string;
  otP_TIP: string;
  otP_NPK: string;
  otP_CAL: string;
  otP_BLO: string;
  otP_ESC: string;
  otP_PIS: string;
  otP_PUE: string;
  otP_POR: string;
  otP_COM: string;
  otP_NJA: string;
  otP_LOC: string;
  otP_TEL: string;
  otP_MOV: string;
  otP_EMA: string;
  otP_POP: string;
  otP_CMU: string;
  otP_CP: string;
  otP_PAI: string;
  otP_FAX: string;

  reS_TIP: string;
  reS_IMP: number;
  reS_FPA: string;
  reS_CCC: string;
  reS_IBAN: string;

  imp: string;
  fpa: string;
  ccc: string;
  iban: string;
  cA_DET: boolean;
  cA_OTR: string;
  sU_GE_SG: boolean;
  sU_GE_CG: boolean;
  sU_ES_A82SG: boolean;
  sU_ES_A83CG: boolean;
  sU_ES_A39SG: boolean;
  sU_ES_A39CG: boolean;
  sU_ES_A113SG: boolean;
  sU_ES_OTR: string;
  dO_AU_MOF: boolean;
  dO_GA_CAS: boolean;
  dO_GA_CSC: boolean;
  dO_GA_OTG: boolean;
  dO_OTR_DOC: string;
  dO_ODS_FAE: boolean;
  dO_ODS_JDO: boolean;
  dO_ODS_FAR: boolean;
  dO_ODS_COP: boolean;
  fna: string;
  ffa: string;
  tdi: string;
  sig: string;
  pro: string;
  mun: string;
  zip: string;
  est: string;
  sis: number;
  vic: number;
  org: string;
  cla: string;
  reg: string;
  def: string;
  esp: string;
  imd: string;
  dif: string;
  rcu: string;
  cpa: string;
  sut: string;
  dac: string;
  rli: string;
  eoa: string;
  odd: string;
  rcC_IEB_BAS: number;
  rcC_IEB_CUO: number;
  rcC_IAB_BAS: number;
  rcC_IAB_CUO: number;
  tot: string;
  res: string;
  rec: string;
  exp: string;
  exe: string;
  oie: string;
  ecd: string;
  esd: string;
  nsj: string;
  reag: string;
  rebu: string;
  reav: string;
  ebi: string;
  ebt: string;
  ibe: string;
  cnd: string;
  otp: string;
  idE_ACO: string;
  idE_RDM: string;
  idE_RECC: string;
  idE_DRECC: string;
  idE_EOP: string;
  idE_ACR: string;
  idE_FAC: string;
  idE_TAC: string;
  idE_TRA: string;
  idE_VAO: string;
  idE_GEM: string;
  idE_RPE: string;
  epe: string;
  ecm: string;
  ons: string;
  ioo: string;
  ist: string;
  bas: string;
  cuo: string;
  auT_C06: number;
  auT_C07: number;
  auT_C08: number;
  auT_C09: number;
  auT_C10: number;
  auT_C11: number;
  auT_C12: number;
  auT_C13: number;
  auT_C14: number;
  auT_C15: number;
  auT_C16: number;
  auT_C17: number;
  auT_C18: number;
  auT_C19: number;
  epi: string;
  moD1: string;
  moD2: string;
  moD3: string;
  moD4: string;
  moD5: string;
  moD6: string;
  moD7: string;
  cap: string;
  car: string;
  tit: string;
  otr: string;
  not: string;
  fpo: string;
  casa: string;
  casb: string;
  casc: string;
  casd: string;
  case: string;
  casf: string;
  casg: string;
  trs: string;
  caf: string;
  cbi: string;
  daf: string;
  dbi: string;
  tod: string;
  nifd: string;
  lug: string;
  fec: string;

  aco: boolean;
  recc: boolean;
  drecc: boolean;
  eop: boolean;
  acr: boolean;
  fac: Date;
  tac: boolean;

  com: boolean;
  nja: string;

  // #region I.G.I.C Devengado
  casilla_1: number;
  casilla_2: number;
  casilla_3: number;
  casilla_4: number;
  casilla_5: number;
  casilla_6: number;
  casilla_7: number;
  casilla_8: number;
  casilla_9: number;
  casilla_10: number;
  casilla_11: number;
  casilla_12: number;
  casilla_13: number;
  casilla_14: number;
  casilla_15: number;
  casilla_16: number;
  casilla_17: number;
  casilla_18: number;

  casilla_19: number;
  casilla_20: number;
  casilla_21: number;
  casilla_22: number;
  casilla_23: number;
  casilla_24: number;
  casilla_25: number;
  // #endregion

  // #region I.G.I.C Deducible
  casilla_26: number;
  casilla_27: number;
  casilla_28: number;
  casilla_29: number;
  casilla_30: number;
  casilla_31: number;
  casilla_32: number;
  casilla_33: number;
  casilla_34: number;
  casilla_35: number;
  casilla_36: number;
  casilla_37: number;
  casilla_38: number;
  casilla_39: number;
  casilla_40: number;
  casilla_41: number;
  casilla_42: number;
  casilla_43: number;
  casilla_44: number;
  casilla_45: number;
  // #endregion

  // #region Resultado
  casilla_46: number;
  casilla_47: number;
  casilla_48: number;
  casilla_49: number;
  casilla_50: number;
  casilla_51: number;
  casilla_I: number;
  casilla_D: number;
  casilla_C: number;
  // #endregion

  // Fix
  sujetoNIF: string;
  sujetoApellido: string;

  constructor() {
    super();
    // this.pagina = 1;
    // this.totalPagina = 2;
    this.modelo = '425'
    this.contact = {
      address: '',
      block: '',
      door: '',
      entrance: '',
      floor: '',
      staircase: '',
      phone: '',
      postalCode: '',
      provinceCode: '',
      municipalityCode: '',
      number: null,
      streetTypeId: null,
      fax: ''
    }
  }
}
